import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import dummyImg from "resources/img/dummy.png";
import { Autoplay, Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import style from "./BannerSwiper.module.css";

function BannerSwiper(props) {
  const { data } = props;
  const navigate = useNavigate();
  

  const [paginationText, setPaginationText] = useState([]); // 페이지네이션에 표시될 텍스트
  const [slides, setSlides] = useState();

  const onBannerDetailClick = (d, img) => {
    if (d.board.name === "banner") {
      if (d.metadata?.link?.length > 0) {
        navigate(d.metadata.link);
      } else {
        navigate("/article/notice/detail", { state: { data: d, img: img } });
      }
    } else {
      navigate("/article/notice/detail", { state: { data: d, img: img } });
    }
  };
  useEffect(() => {
    if (data) {
      let titles = data.map((slide) => slide.title);
      setSlides(data);
      setPaginationText(titles);
    }
  }, [data]);

  return (
    <>
      {slides && (
        <div className={style.swiperContainer}>
          <Swiper
            spaceBetween={30}
            centeredSlides={true}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            pagination={{
              clickable: true,
              el: ".unique-pagination", // 고유 클래스명으로 설정
              renderBullet: (index, className) => {
                return `<span class="${className} unique-pagination-text">${paginationText[
                  index
                ] || "No Title"}</span>`;
              },
            }}
            modules={[Autoplay, Pagination, Navigation]}
            className={"bannerSwiper"}
          >
            {slides.map((slide, index) => (
              <SwiperSlide key={index}>
                <div
                  className={style.wrap}
                  // onClick={() => onBannerDetailClick(slide, bannerImg[index])}
                >
                  <img
                    className={style.slideImg}
                    width={"100%"}
                    style={{ maxHeight: "530px" }}
                    src={
                      slide.metadata?.banner ? slide.metadata?.banner : dummyImg
                    }
                    alt=""
                  />
                  {/* 나중에 쓰게 될 배너 이미지 뷰   */}
                  {/* {slide.img.startsWith("PHA") ? (
                            //     <QuillViewer value={decode(slide.img)} />
                            // ) : (
                            //     <QuillViewer value={slide.img} />
                            // )} */}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="unique-pagination"></div>
        </div>
      )}
    </>
  );
}

export default BannerSwiper;
